module.exports = __webpack_public_path__ + "img/art_jyoji.b57fdf98.png";